export default __webpack_public_path__ + "static/media/job_offer17_l.1d22ba7b.jpg";